import { useRouter } from 'next/router';
import { memo, useCallback } from 'react';

import { LogOutIcon, UserRoundPlusIcon } from '@air/design-icons';
import { Avatar } from '@air/primitive-avatar';
import { DropdownMenuItem, DropdownMenuSeparator } from '@air/primitive-dropdown-menu';

import { Routes } from '~/constants/routes';
import { useAccountContext } from '~/providers/AccountProvider';
import { useLogout } from '~/swr-hooks/auth/useLogout';
import { getAvatarImageSrc } from '~/utils/getAvatarImageSrc';

export const WorkspaceHeaderInformationDropdownAccountItems = memo(() => {
  const router = useRouter();
  const { data: account } = useAccountContext();
  const { logout } = useLogout();

  const onAccountSettings = useCallback(() => {
    router.push(Routes.account.myAccount);
  }, [router]);

  const onLogout = useCallback(() => {
    logout();
  }, [logout]);

  if (!account) {
    return null;
  }

  return (
    <>
      <DropdownMenuSeparator />
      <div className="-m-2 flex flex-col ads:bg-raised bg-gray-2 px-2">
        <div className="flex gap-2 pt-2">
          <div className="shrink-0 p-1">
            <Avatar
              alt={`${account.firstName} ${account.lastName} avatar`}
              size={32}
              src={getAvatarImageSrc(account.avatar, 24)}
              style={{ cursor: 'pointer' }}
              text={account.firstName && account.lastName ? `${account.firstName[0]}${account.lastName[0]}` : ''}
              colorSeed={account.id}
            />
          </div>
          <div>
            <div className="truncate font-medium ads:text-secondary text-14 text-gray-11">
              {account.firstName} {account.lastName}
            </div>
            <div className="truncate ads:text-metadata text-12 text-gray-9">{account.email}</div>
          </div>
        </div>

        <div className="flex flex-col gap-1 py-2">
          <DropdownMenuItem
            label="Account settings"
            onSelect={onAccountSettings}
            prefix={<UserRoundPlusIcon size="sm" />}
          />
          <DropdownMenuItem label="Log out" onSelect={onLogout} prefix={<LogOutIcon size="sm" />} data-id="log-out" />
        </div>
      </div>
    </>
  );
});

WorkspaceHeaderInformationDropdownAccountItems.displayName = 'WorkspaceHeaderInformationDropdownAccountItems';
